import { Flex } from '@modusign/design-system';
import { useDispatch, useSelector } from 'react-redux';

import ExportInputValuesSnackBarContainer from '@app/features/exportInputValues/components/ExportInputValuesSnackBarContainer';
import { DocumentUploadModal as ExternalDocumentUploadModal } from '@app/features/externalDocument';
import BatchUpdateSnackBar from '@app/features/externalDocument/components/BatchUpdateSnackBar';
import DocumentUploadModalSnackBar from '@app/features/externalDocument/components/DocumentUploadModalSnackBar';
import {
  getExternalDocumentUploadStatus,
  getIsModalMinimized,
  getIsNotIdleStatus,
  getUploadingSummary,
  toggleModalMinimize,
} from '@app/features/externalDocument/state';

export default function SnackBars() {
  const dispatch = useDispatch();

  const isUploadModalOpen = useSelector(getIsNotIdleStatus);
  const isUploadModalMinimized = useSelector(getIsModalMinimized);
  const uploadSummary = useSelector(getUploadingSummary);
  const uploadStatus = useSelector(getExternalDocumentUploadStatus);
  const toggleUploadModalMinimize = () => dispatch(toggleModalMinimize());

  return (
    <>
      <ExternalDocumentUploadModal />
      <Flex
        alignItems="center"
        bottom="30px"
        flexDirection="column"
        ml="50%"
        position="fixed"
        sx={{ transform: 'translateX(-50%)' }}
        zIndex={999}
      >
        <ExportInputValuesSnackBarContainer />
        {isUploadModalOpen && isUploadModalMinimized && (
          <DocumentUploadModalSnackBar
            failedDocumentCount={uploadSummary.failed}
            remainedDocumentCount={uploadSummary.idle + uploadSummary.pending}
            status={uploadStatus}
            succeededDocumentCount={uploadSummary.succeeded}
            onMaximize={toggleUploadModalMinimize}
          />
        )}
        <BatchUpdateSnackBar />
      </Flex>
    </>
  );
}
